import React, { useEffect, useRef } from 'react';
import PageWrapper from 'Pages/PageWrapper';
import SignIn from 'Pages/SignIn';
import R from 'ramda';
import { matchPath, Redirect, Route, Switch } from 'react-router-dom';
import { compile } from 'path-to-regexp';

/**
 * TODO
 * - Transition blocking when leaving from dirty form
 * - Authorization: admin, manager, trader, viewer
 * - Flag based routing, dynamic routing, feature toggle
 */

export const UUID =
  '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';

export const PRIVATE_ROUTES = {
  home: '/',
  overview: '/overview',
  marketplace: '/marketplace',
  marketdepth: `/marketplace/:productId(${UUID})`,

  dashboard: '/dashboard',
  // dashboard2: '/dashboard2',

  products: '/products',
  product: `/products/:id(${UUID})/quick`,
  productSpecifications: `/products/:id(${UUID})/specifications`,

  tenders: '/tenders',

  orders: '/orders',
  orderNew: '/orders/:orderType(bid|offer)',
  orderEdit: `/orders/:orderId(${UUID})/edit`,

  trades: '/trades',

  account: '/account',

  config: '/config',

  routes: '/routes',

  participants: '/participants',
  locations: '/locations',
  customers: '/customers',
  consignees: '/partners',
  customerRequest: '/customer-requests',
  reports: '/reports',

  consolidation: '/consolidation',
  deliveries: '/deliveries',
  users: '/users',

  futures: '/futures',
  duplicate: '/duplicate', // duplicate (tender) orders
};

export const ROUTES = {
  signIn: '/signin',
  loginEmail: '/login/email',
  ...PRIVATE_ROUTES,
};

export function routeUrl(route, params = {}) {
  return compile(route)(params);
}

export function useBaseUrl(base, baseParams = {}) {
  return [
    // route
    function (route, params) {
      return routeUrl([base, route].join('/'), { ...baseParams, ...params });
    },
    // match
    function (route, params) {
      return `${base}/${route}`;
    },
  ];
}

export function checkIsModal(pathname) {
  return R.any(
    path => matchPath(pathname, { path }),
    [
      '/preview',
      ROUTES.orderNew,
      ROUTES.orderEdit,
      ROUTES.marketplace,
      ROUTES.marketdepth,
      ROUTES.product,
      ROUTES.productSpecifications,
      ROUTES.account,
      ROUTES.futures,
      ROUTES.duplicate,
    ]
  );
}

export function usePreviousNormalLocation(value) {
  const ref = useRef();
  useEffect(() => {
    if (!checkIsModal(value.pathname)) {
      ref.current = value;
    }
  });
  return ref.current;
}

export function PrivateRoute({ component: Component, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.signIn,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export function Routes({ user }) {
  return (
    <Switch>
      <Route path={[ROUTES.signIn, ROUTES.loginEmail]} component={SignIn} />
      <PrivateRoute
        path={R.values(PRIVATE_ROUTES)}
        component={PageWrapper}
        user={user}
      />
    </Switch>
  );
}
